import api from '@/services/Api';

class Settings {
  /**
   * Fetch all the Settings
   * @returns {AxiosPromise<any>}
   */
  static all() {
    return api.get('/settings');
  }
}

export default Settings;
